import React, { useState, useEffect } from "react";
import { ref, update, remove, onValue } from "firebase/database";
import { db } from "../../../../assets/firebase/firebaseconfig";
import "./styles.css"; 

const CommentManager = () => {
  const [comments, setComments] = useState([]);
  const [filter, setFilter] = useState("all");
  const [replyText, setReplyText] = useState({});
  const currentUser = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const commentRef = ref(db, "comments");
    const unsubscribe = onValue(commentRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const list = Object.keys(data).map((key) => ({ id: key, ...data[key] }));
        setComments(list.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
      } else { setComments([]); }
    });
    return () => unsubscribe();
  }, []);

  const handleSendReply = async (id, currentChatHistory = []) => {
    const text = replyText[id];
    if (!text?.trim()) return;
    const newMessage = {
      sender: "Admin",
      senderName: currentUser?.username || "Quản trị viên",
      text: text,
      time: new Date().toISOString(),
    };
    const updatedHistory = [...(currentChatHistory || []), newMessage];
    await update(ref(db, `comments/${id}`), { chatHistory: updatedHistory, status: "Đã xong" });
    setReplyText({ ...replyText, [id]: "" });
  };

  const handleDeleteFull = async (id) => {
    if (window.confirm("Xóa vĩnh viễn đánh giá này?")) {
      await remove(ref(db, `comments/${id}`));
    }
  };

  const handleDeleteAdminReply = async (id, currentChatHistory = []) => {
    if (window.confirm("Gỡ phản hồi của Shop và giữ lại tin nhắn khách?")) {
      const updatedHistory = (currentChatHistory || []).filter(chat => chat.sender !== "Admin");
      await update(ref(db, `comments/${id}`), { chatHistory: updatedHistory, status: "Đợi trả lời" });
    }
  };

  const filteredComments = comments.filter((cmt) => {
    if (filter === "pending") return cmt.status === "Đợi trả lời";
    if (filter === "replied") return cmt.status === "Đã xong";
    return true;
  });

  return (
    <div className="admin-content-inner">
      <div className="page-header">
        <h1>📊 Quản Lý Đánh Giá</h1>
      </div>

      <div className="filter-bar-container">
        <div className="card stat-card">Tổng: <b>{comments.length}</b></div>
        <div className="card stat-card wait-text">Chờ: <b>{comments.filter(c => c.status === "Đợi trả lời").length}</b></div>
      </div>

      <div className="filter-tabs">
        {["all", "pending", "replied"].map((type) => (
          <button key={type} className={`btn-filter ${filter === type ? "active" : ""}`} onClick={() => setFilter(type)}>
            {type === "all" ? "Tất cả" : type === "pending" ? "Chờ" : "Đã xong"}
          </button>
        ))}
      </div>

      <div className="card table-card">
        <div className="table-responsive">
          <table className="main-table">
            <thead>
              <tr>
                <th>Khách hàng</th>
                <th>Nội dung</th>
                <th>Trạng thái</th>
                <th>Thao tác</th>
              </tr>
            </thead>
            <tbody>
              {filteredComments.map((cmt) => (
                <tr key={cmt.id}>
                  <td data-label="TÊN KHÁCH HÀNG:">
                    <div className="main-name">{cmt.userName}</div>
                    <div className="sub-tag">ID: {cmt.productId?.slice(-5)}</div>
                  </td>
                  <td data-label="NỘI DUNG:">
                    <div className="cmt-content-main">{cmt.content}</div>
                    <div className="chat-history-box">
                      {cmt.chatHistory?.map((chat, i) => (
                        <div key={i} className="chat-item">
                          <span className={chat.sender === "Admin" ? "text-admin" : "text-user"}>
                            {chat.sender === "Admin" ? "Shop: " : "Khách: "}
                          </span>
                          {chat.text}
                        </div>
                      ))}
                    </div>
                  </td>
                  <td data-label="TRẠNG THÁI:">
                    <span className={`status-badge ${cmt.status === "Đã xong" ? "done" : "wait"}`}>
                      {cmt.status === "Đã xong" ? "● Hoàn tất" : "● Chờ trả lời"}
                    </span>
                  </td>
                  <td data-label="THAO TÁC:">
                    <div className="action-col">
                      <textarea 
                        className="reply-input"
                        value={replyText[cmt.id] || ""}
                        onChange={(e) => setReplyText({ ...replyText, [cmt.id]: e.target.value })}
                        placeholder="Nhập nội dung..."
                      />
                      <button className="btn-send-reply" onClick={() => handleSendReply(cmt.id, cmt.chatHistory)}>
                        Gửi phản hồi
                      </button>
                      <div className="action-btns-grid">
                        <button className="btn-del-sub" onClick={() => handleDeleteAdminReply(cmt.id, cmt.chatHistory)}>
                          Gỡ Shop
                        </button>
                        <button className="btn-del-main" onClick={() => handleDeleteFull(cmt.id)}>
                          Xóa Hết
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CommentManager;